"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClawAbilityHandler = exports.ClawActorAbilityFactory = exports.ClawAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
class ClawAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Claw;
        this.__typeName = "Claw";
    }
}
exports.ClawAbilityArgs = ClawAbilityArgs;
let ClawActorAbilityFactory = class ClawActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Claw", "OneEnemies", 1);
    }
};
ClawActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Claw")
], ClawActorAbilityFactory);
exports.ClawActorAbilityFactory = ClawActorAbilityFactory;
let ClawAbilityHandler = class ClawAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 55)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.BleedingEffectArgs("Power", 10),
                });
            }
        });
    }
};
ClawAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Claw)
], ClawAbilityHandler);
exports.ClawAbilityHandler = ClawAbilityHandler;
